import { ReactNode } from 'react'

export interface TextBlockProps {
  children: ReactNode
}
export function TextBlock({ children }: TextBlockProps) {
  return <div className="col-span-12 space-y-6">{children}</div>
}
